<div class="container" *ngIf="isLoading"><span>Chargement...</span></div>
<div class="container" *ngIf="!isLoading">
    <div class="container" *ngIf="registrations.length === 0">
        <span>Pas encore de stagiaire</span>
    </div>

    <div class="mt-1">
        <button
            (click)="redirectionToSurveyReport()"
            class="btn btn-primary btn-sm"
            style="margin-bottom: 4px"
        >
            <span class="fa fa-external-link-square"></span>
            Visualiser le rapport d'évaluation
        </button>
    </div>
</div>



// WEBPACK FOOTER //
// ./src/app/_screens/session/detail/survey-monkey/survey-monkey.component.html